import { s3ProgressConfig } from "../utils/uploadProgress";
import axios from "axios";

import { api } from "./axiosClient";

/** Hands a downloaded blob to the browser as a file save. */
export function saveBlobAsFile(blob: Blob, fileName: string) {
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");

  link.href = url;
  link.download = fileName;

  document.body.appendChild(link);
  link.click();
  link.remove();

  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const receivableApi = {
  /**
   * Search receivables
   */
  searchReceivables: async (payload: any) => {
    const response = await api.post("/receivable/search", payload);

    return response.data;
  },

  /**
   * Add / create receivable
   */
  addReceivable: async (data: any) => {
    const response = await api.post("/receivable/create", data);

    return response.data;
  },

  /**
   * Edit / update receivable
   */
  editReceivable: async (data: any) => {
    const response = await api.post("/receivable/edit", data);

    return response.data;
  },

  /**
   * Change receivable status
   */
  changeStatusReceivable: async (data: {
    receivableId: string;
    status: number;
  }) => {
    return await api.post("/receivable/changestatus", data);
  },

  activateReceivable: async (id: string) => {
    return await api.post("/receivable/activate", { id });
  },

  deactivateReceivable: async (id: string) => {
    return await api.post("/receivable/deactivate", { id });
  },

  /**
   * Remove receivable
   */
  removeReceivable: async (id: string) => {
    return await api.post("/receivable/remove", { id });
  },

  initUpload: async (ids: string[], groupId?: string) => {
    const response = await api.post("/receivable/initupload", { ids, groupId });
    return response.data;
  },

  uploadToS3: async (s3Url: string, file: File) => {
    return await axios.put(s3Url, file, {
      ...s3ProgressConfig(file),
      headers: {
        "Content-Type": file.type,
      },
    });
  },

  uploadMedia: async (contractId: string, medias: any[]) => {
    return await api.post("/receivableInvoice/uploadmedia", {
      contractId,
      medias,
    });
  },

  initUploadInvoice: async (ids: string[], groupId?: string) => {
    const response = await api.post("/receivableInvoice/initupload", {
      ids,
      groupId,
    });
    return response.data;
  },

  uploadToS3Invoice: async (s3Url: string, file: File) => {
    return await axios.put(s3Url, file, {
      ...s3ProgressConfig(file),
      headers: {
        "Content-Type": file.type,
      },
    });
  },

  uploadMediaInvoice: async (contractId: string, medias: any[]) => {
    return await api.post("/receivableInvoice/uploadmedia", {
      contractId,
      medias,
    });
  },

  getInvoiceMediaLink: async (
    ids: string[],
    size: number = 1,
    groupId?: string,
  ): Promise<{ links: Array<{ id: string; link: string }> }> => {
    const response = await api.post("/receivableInvoice/getmedialink", {
      ids,
      size,
      groupId,
    });
    return response.data;
  },
};
